import { getFontTokenStyle, marginBottomSpacing } from '@koaly/mixins';
import styled from 'styled-components';

const Paragraph = styled.p `
  /* Reset */
  margin: 0;
  white-space: pre-wrap;

  ${({ size, variant, appearance }) => getFontTokenStyle('paragraph', size, variant, appearance)};
  ${({ spaceAfter }) => spaceAfter && marginBottomSpacing(spaceAfter)};
`;
Paragraph.defaultProps = {
    size: 'medium',
};

export { Paragraph };
//# sourceMappingURL=Paragraph.js.map
